module.exports = __webpack_public_path__ + "static/img/chengxinwangzhan@2x.4a4b433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/chengxinwangzhan@2x.png
// module id = ahqO
// module chunks = 1